var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = /*#__PURE__*/function () {
  "use strict";

  function FixedFIFO(hwm) {
    _classCallCheck(this, FixedFIFO);

    if (!(hwm > 0) || (hwm - 1 & hwm) !== 0) throw new Error('Max size for a FixedFIFO should be a power of two');
    this.buffer = new Array(hwm);
    this.mask = hwm - 1;
    this.top = 0;
    this.btm = 0;
    this.next = null;
  }

  _createClass(FixedFIFO, [{
    key: "push",
    value: function push(data) {
      if (this.buffer[this.top] !== undefined) return false;
      this.buffer[this.top] = data;
      this.top = this.top + 1 & this.mask;
      return true;
    }
  }, {
    key: "shift",
    value: function shift() {
      var last = this.buffer[this.btm];
      if (last === undefined) return undefined;
      this.buffer[this.btm] = undefined;
      this.btm = this.btm + 1 & this.mask;
      return last;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.buffer[this.btm] === undefined;
    }
  }]);

  return FixedFIFO;
}();